import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CollaborationSection = () => {
    const { t } = useTranslation();

    const initialMainContent = {
            id: 0,                   
            title: t('collaboration.visionTitle'),
            description: t('collaboration.visionDescription'),
            fullDescription: t('collaboration.visionFullDescription'),
            image: '/assets/images/new-img/vizyon.png',
    };

    const initialFeatures = [
        {
            id: 1,
            title: t('collaboration.missionTitle'),
            description: t('collaboration.missionDescription'),
            fullDescription: t('collaboration.missionFullDescription'),
            image: '/assets/images/new-img/misyon.png',
        },
        {
            id: 2,
            title: t('collaboration.partnerTitle'),
            description: t('collaboration.partnerDescription'),
            fullDescription: t('collaboration.partnerFullDescription'),
            image: '/assets/images/new-img/partner.jpg',
        },
        {
            id: 3,
            title: t('collaboration.marketMakerTitle'),
            description: t('collaboration.marketMakerDescription'),
            fullDescription: t('collaboration.marketMakerFullDescription'),
            image: '/assets/images/new-img/piyasa-yapici.jpg',
        }
    ];

    const [mainContent, setMainContent] = useState(initialMainContent);
    const [features, setFeatures] = useState(initialFeatures);

    const handleFeatureClick = (clickedFeature) => {
        // Sağdaki öğeyi solda göster, soldakini sağdakiler arasına ekle
        const newFeatures = features.map(feature => 
            feature.id === clickedFeature.id ? mainContent : feature
        );
        
        setFeatures(newFeatures);
        setMainContent(clickedFeature);
    };

    return (
        <div className="collaboration-section">
            <div className="container">
                <div className="row align-items-start">
                    <div className="col-lg-5 mb-5 mb-lg-0">
                        <div className="collaboration-main">
                            <div className="collaboration-main-image">
                                <img src={mainContent.image} alt={mainContent.title} />
                            </div>
                            <h2 className="collaboration-title">{mainContent.title}</h2>
                            <p className="collaboration-description">
                                {mainContent.fullDescription || mainContent.description}
                            </p>
                            {(mainContent.id === 0 || mainContent.id === 1) && (
                                <Link to={mainContent.id === 0 ? "/vision" : "/mission"} className="collaboration-link">
                                    {t('collaboration.learnMore')} →
                                </Link>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row g-4">
                            {features.map((feature) => (
                                <div key={feature.id} className="col-12">
                                    <div 
                                        className="feature-card" 
                                        onClick={() => handleFeatureClick(feature)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="feature-card-image">
                                            <img src={feature.image} alt={feature.title} />
                                        </div>
                                        <div className="feature-card-content">
                                            <h3 className="feature-card-title">{feature.title}</h3>
                                            <p className="feature-card-description">{feature.description}</p>
                                            <span className="feature-card-more">{t('collaboration.clickToLearnMore')}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollaborationSection;
